"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { Phone } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { useEffect, useRef, useState } from "react";
export default function Hero() {
  const {
    ref: containerRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const parallaxRef = useRef<HTMLDivElement>(null);
  const [scrollY, setScrollY] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const parallaxOffset = scrollY * 0.3;
  return <section ref={containerRef} className="relative w-full h-screen min-h-[600px] overflow-hidden">
      {}
      <div ref={parallaxRef} className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: "url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1521869/img/renovated_kitchen_hero_background.png)",
      transform: `translateY(${parallaxOffset}px)`,
      transition: "transform 150ms cubic-bezier(0.4,0,0.2,1)"
    }}>
        {}
        <div className="absolute inset-0 bg-black/50" />
      </div>

      {}
      <div className="relative z-10 flex items-center justify-center h-full px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center">
          {}
          <h1 className={`font-display text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            Your Trusted Home Renovation &amp; Construction Experts
          </h1>

          {}
          <p className={`text-lg sm:text-xl md:text-2xl text-white/90 mb-8 font-sans transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] delay-100 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            Serving Jersey &amp; PA – Kitchens, Bathrooms, Flooring, Painting
            &amp; More
          </p>

          {}
          <div className={`mb-8 transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] delay-200 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            <Button asChild size="lg" className="bg-primary text-white px-8 py-6 text-lg font-semibold rounded-md shadow-medium hover:bg-primary-hover hover:scale-[1.02] active:bg-primary-active transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] focus-ring">
              <Link to="/ContactPage">Request Free Estimate</Link>
            </Button>
          </div>

          {}
          <div className={`flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8 text-white transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] delay-[300ms] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            <Link to="tel:2017364633" className="inline-flex items-center gap-2 text-lg font-semibold hover:text-primary-light transition-colors duration-[var(--duration-medium)]">
              <Phone className="size-5" />
              <span>201-736-4633</span>
            </Link>
            <span className="hidden sm:inline text-white/50">|</span>
            <Link to="tel:6464064601" className="inline-flex items-center gap-2 text-lg font-semibold hover:text-primary-light transition-colors duration-[var(--duration-medium)]">
              <Phone className="size-5" />
              <span>646-406-4601</span>
            </Link>
          </div>
        </div>
      </div>
    </section>;
}